import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'percentage',
  standalone: true
})
export class PercentagePipe implements PipeTransform {

  transform(s: string | null, format:boolean = true): string {

    if(s == null) return '';

    let n = s.toString().replace(/\D/g, '').padStart(3, '0')
    // console.warn('PercentagePipe -> transform', 's', s, 'n', n, 'format', format) 

    let nInteger = parseInt(n.substring(0, n.length-2))
    if(isNaN(nInteger))
      nInteger = 0
    // console.error('PercentagePipe -> nInteger', nInteger)

    let nDecimal = n.substring(n.length-2)
    // console.error('PercentagePipe -> nDecimal', nDecimal)

    if (format)
      return `${nInteger},${nDecimal}%`
    else 
      return (nInteger + '.' + nDecimal)
  }

}
